(function () {
    'use strict';

    angular
        .module('app.directive')
        .directive('taiBulletin', taiBulletin);

    function taiBulletin() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            templateUrl: 'directive/taiBulletin.html',
            restrict: 'E',
            scope: {
                data: '=',
                type: '@'
            }
        };
        return directive;

        function link() { }
    }
    /* @ngInject */
    function ControllerController(modalService,bulletinService, $routeParams, $rootScope, enumService,
        $timeout, $location) {
        let vm = this;
        let bulletinGetByPaggerDto = {
            menuSerilNo: '',
            bulletinTypeSerilNo: '',
            PaggerChoice: 1,
            noticePage: 1
        };
        vm.isMobile = modalService.isMobile();
        vm.selectFirstMenu = selectFirstMenu;
        vm.selectBulletinType = selectBulletinType;
        vm.clickDefaultType = clickDefaultType;
        vm.getMoreList = getMoreList;
        vm.getNoticeMoreList = getNoticeMoreList;
        vm.redirectToDetail = redirectToDetail;

        vm.view = {
            typeNo: 0
        };


        onInit();

        function onInit() {
            //console.log('bull:',vm.data.notices.bulletins.length);
            $timeout(function () {
                vm.bulletin = $rootScope.translate.bulletin;
                vm.noticeCenter = $rootScope.translate.noticeCenter;
            }, $rootScope.translate);
            if (sessionStorage.getItem("perSerilNo")) {
                vm.isLogin = true;
            } else {
                vm.isLogin = false;
            }
            getHistoryBind();
        }

        function getHistoryBind() {
            if ($routeParams.isHistory) {
                var cache = JSON.parse(sessionStorage.getItem('bulletinCache'));
                if (cache) {
                    if (cache.menuItem) {
                        vm.data.menuItem = cache.menuItem;
                        bulletinGetByPaggerDto.menuSerilNo = cache.menuItem.menuSerilNo;
                    }
                    if (cache.typeSerilNo) {
                        vm.view.typeNo = cache.typeSerilNo;
                        bulletinGetByPaggerDto.bulletinTypeSerilNo = cache.typeSerilNo;
                    }
                }
            }
        }

        function selectBulletinType(item) {
            bulletinGetByPaggerDto.PaggerChoice = 1;
            vm.view.typeNo = item.bulletinTypeSerilNo;
            bulletinGetByPaggerDto.bulletinTypeSerilNo = item.bulletinTypeSerilNo;
            getBulletinDetail(bulletinGetByPaggerDto, 'bulletinType');
        }

        function selectFirstMenu() {
            bulletinGetByPaggerDto.PaggerChoice = 1;
            if (vm.data.menuItem) {
                bulletinGetByPaggerDto.menuSerilNo = vm.data.menuItem.menuSerilNo;
            } else {
                if ($routeParams.menuSerilNo) {
                    bulletinGetByPaggerDto.menuSerilNo = $routeParams.menuSerilNo;
                } else {
                    bulletinGetByPaggerDto.menuSerilNo = null;
                }
            }
            getBulletinDetail(bulletinGetByPaggerDto, 'firstMenu');
        }

        function getMoreList() {
            bulletinGetByPaggerDto.PaggerChoice++;
            getBulletinDetail(bulletinGetByPaggerDto, null);
        }

        function getNoticeMoreList() {
            bulletinGetByPaggerDto.noticePage++;
            //2為通知中心的意思
            bulletinGetByPaggerDto.dataType = 2;
            setSiteCode(bulletinGetByPaggerDto);
            bulletinService.getTsunMoreList(bulletinGetByPaggerDto).then(function (data) {
                vm.data.notices.bulletins = _.concat(vm.data.notices.bulletins, data.data.notices.bulletins);
                vm.data.hasNoticeMore = data.data.hasNoticeMore;
            });
        }

        function setSiteCode(bulletinParam) {
            switch (vm.type) {
                case 'bulletin':
                    bulletinParam.siteCode = enumService.siteCode.hrOutside;
                    break;
                case 'notice':
                    bulletinParam.siteCode = enumService.siteCode.tsunOut;
                    break;
            }
        }

        function getBulletinDetail(bulletinParam, choiceType) {
            // 1是公佈欄的意思
            bulletinParam.dataType = 1;
            switch (choiceType) {
                case 'bulletinType':
                    bulletinParam.isChoiceBulletinType = true;
                    break;
                case 'firstMenu':
                    bulletinParam.isChoiceMenu = true;
                    break;
            }
            setSiteCode(bulletinParam);
            bulletinService.getMoreByChoice(bulletinParam).then(function (data) {
                reBindView(choiceType, bulletinParam, data);
            });
        }

        function reBindView(choiceType, bulletinParam, data) {
            switch (choiceType) {
                case 'bulletinType':
                    vm.data.menuFirstDtos = data.data.menuFirstDtos;
                    vm.data.bulletinWithCountDto.bulletins = data.data.bulletinWithCountDto.bulletins;
                    break;
                case 'firstMenu':
                    vm.data.bulletinSearchViews = data.data.bulletinSearchViews;
                    vm.data.bulletinWithCountDto.bulletins = data.data.bulletinWithCountDto.bulletins;
                    break;
                default:
                    vm.data.bulletinWithCountDto.bulletins = _.concat(vm.data.bulletinWithCountDto.bulletins, data.data.bulletinWithCountDto.bulletins);
                    break;
            }
            vm.data.hasMore = data.data.hasMore;
            bulletinParam.isChoiceBulletinType = false;
            bulletinParam.isChoiceMenu = false;
            return bulletinParam;
        }

        function clickDefaultType() {
            bulletinGetByPaggerDto.PaggerChoice = 1;
            vm.view.typeNo = 0;
            bulletinGetByPaggerDto.bulletinTypeSerilNo = 0;
            getBulletinDetail(bulletinGetByPaggerDto, 'bulletinType');
        }

        function redirectToDetail(item) {
            let param = {
                typeSerilNo: bulletinGetByPaggerDto.bulletinTypeSerilNo,
                menuItem: vm.data.menuItem,
            };

            $location.path('/bulletin/detail/' + item.bulletinSerilNo).search('menu', 2);

            sessionStorage.setItem('bulletinCache', JSON.stringify(param));
        }
    }
})();
